// import React, { useState } from "react";
// import "./Profile_Vendor.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";

// const Profile_Vendor = () => {
//   const [isEditing, setIsEditing] = useState(false);
//   const [activeTab, setActiveTab] = useState("personal");
//   const [profileImage, setProfileImage] = useState(
//     "/assets/images/profile-icon.png",
//   );

//   const handleButtonClick = () => {
//     if (isEditing) {
//       console.log("Profile Saved!");
//     }
//     setIsEditing(!isEditing);
//   };

//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       const imageUrl = URL.createObjectURL(file);
//       setProfileImage(imageUrl);
//       console.log("File selected:", file.name);
//     }
//   };

//   return (
//     <div className="profile-wrapper">
//       <div className="profile-container container">
//         <div className="profile-card">
//           <div className="profile-image-wrapper">
//             <input
//               type="file"
//               id="profile-image-upload"
//               hidden
//               accept="image/*"
//               onChange={handleFileChange}
//             />

//             <img src={profileImage} alt="profile" className="profile-image" />
//             <label
//               htmlFor="profile-image-upload"
//               className="edit-icon"
//               style={{ cursor: "pointer" }}
//             >
//               <FontAwesomeIcon icon={faPencilAlt} />
//             </label>
//           </div>

//           <div className="profile-tabs">
//             <button
//               className={`tab-btn ${activeTab === "personal" ? "active" : ""}`}
//               onClick={() => setActiveTab("personal")}
//             >
//               Personal
//             </button>
//             <button
//               className={`tab-btn ${activeTab === "shop" ? "active" : ""}`}
//               onClick={() => setActiveTab("shop")}
//             >
//               Shop
//             </button>
//           </div>
//           <div className="profile-form">
//             {activeTab === "personal" ? (
//               <>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <input
//                       type="text"
//                       id="name"
//                       placeholder="Enter Full Name"
//                     />
//                     <label>Full Name</label>
//                   </div>
//                   <div className="form-group">
//                     <label>City</label>
//                     <input type="text" id="city" placeholder=" Enter City" />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Mobile No</label>
//                     <input type="text" placeholder="Enter Mobile No" />
//                   </div>
//                   <div className="form-group">
//                     <label>State</label>
//                     <input type="text" placeholder="Enter State " />
//                   </div>
//                 </div>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Whatsapp No</label>
//                     <input type="text" placeholder="Enter Whatsapp No" />
//                   </div>
//                   <div className="form-group">
//                     <label>Material</label>
//                     <input type="text" placeholder="Enter Material" />
//                   </div>
//                 </div>
//               </>
//             ) : (
//               <>
//                 <div className="form-row">
//                   <div className="form-group">
//                     <label>Shop/Showroom Name</label>
//                     <input type="text" placeholder="Enter Shop/Showroom Name" />
//                   </div>
//                   <div className="form-group">
//                     <label>Category</label>
//                     <input type="text" placeholder="Enter Category" />
//                   </div>
//                 </div>
//               </>
//             )}

//             <button
//               className={isEditing ? "save-profile-btn" : "edit-profile-btn"}
//               onClick={handleButtonClick}
//             >
//               {isEditing ? "Save Profile" : "Edit Profile"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Profile_Vendor;
import React, { useState, useEffect } from "react";
import "./Profile_Vendor.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import Account_Created_Modal from "../login/account-created-modal/Account_Created_Modal";

const Profile_Vendor = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState("personal");
  const [showSuccess, setShowSuccess] = useState(false); // Success modal state
  const [profileImage, setProfileImage] = useState(
    "/assets/images/profile-icon.png",
  );

  // Auto-close logic: Closes the modal after 3 seconds
  useEffect(() => {
    if (showSuccess) {
      const timer = setTimeout(() => {
        setShowSuccess(false);
      }, 3000);
      return () => clearTimeout(timer); // Cleanup timer on unmount
    }
  }, [showSuccess]);

  const handleButtonClick = () => {
    if (isEditing) {
      console.log("Profile Saved!");
      setShowSuccess(true); // Trigger success modal on save
    }
    setIsEditing(!isEditing);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl);
      console.log("File selected:", file.name);
    }
  };

  return (
    <div className="profile-wrapper">
      <div className="profile-container container">
        <div className="profile-card">
          <div className="profile-image-wrapper">
            <input
              type="file"
              id="profile-image-upload-vendor"
              hidden
              accept="image/*"
              onChange={handleFileChange}
            />

            <img src={profileImage} alt="profile" className="profile-image" />
            <label
              htmlFor="profile-image-upload-vendor"
              className="edit-icon"
              style={{ cursor: "pointer" }}
            >
              <FontAwesomeIcon icon={faPencilAlt} />
            </label>
          </div>

          <div className="profile-tabs">
            <button
              className={`tab-btn ${activeTab === "personal" ? "active" : ""}`}
              onClick={() => setActiveTab("personal")}
            >
              Personal
            </button>
            <button
              className={`tab-btn ${activeTab === "shop" ? "active" : ""}`}
              onClick={() => setActiveTab("shop")}
            >
              Shop
            </button>
          </div>
          <div className="profile-form">
            {activeTab === "personal" ? (
              <>
                <div className="form-row">
                  <div className="form-group">
                    <input
                      type="text"
                      id="name"
                      placeholder="Enter Full Name"
                      disabled={!isEditing}
                    />
                    <label>Full Name</label>
                  </div>
                  <div className="form-group">
                    <label>City</label>
                    <input
                      type="text"
                      id="city"
                      placeholder=" Enter City"
                      disabled={!isEditing}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Mobile No</label>
                    <input
                      type="text"
                      placeholder="Enter Mobile No"
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="form-group">
                    <label>State</label>
                    <input
                      type="text"
                      placeholder="Enter State "
                      disabled={!isEditing}
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label>Whatsapp No</label>
                    <input
                      type="text"
                      placeholder="Enter Whatsapp No"
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="form-group">
                    <label>Material</label>
                    <input
                      type="text"
                      placeholder="Enter Material"
                      disabled={!isEditing}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="form-row">
                  <div className="form-group">
                    <label>Shop/Showroom Name</label>
                    <input
                      type="text"
                      placeholder="Enter Shop/Showroom Name"
                      disabled={!isEditing}
                    />
                  </div>
                  <div className="form-group">
                    <label>Category</label>
                    <input
                      type="text"
                      placeholder="Enter Category"
                      disabled={!isEditing}
                    />
                  </div>
                </div>
              </>
            )}

            <button
              className={isEditing ? "save-profile-btn" : "edit-profile-btn"}
              onClick={handleButtonClick}
            >
              {isEditing ? "Save Profile" : "Edit Profile"}
            </button>
          </div>
        </div>
      </div>

      <Account_Created_Modal
        showAccountModal={showSuccess}
        handleAccountModalClose={() => setShowSuccess(false)}
        text="Profile Saved Successfully!"
      />
    </div>
  );
};

export default Profile_Vendor;
